import {
  AccountBoxTwoTone,
  AttachFile,
  BookmarkAdded,
  DashboardTwoTone,
  Menu,
  Message,
  NotificationsActive,
  Payments,
  Report
} from '@mui/icons-material'
import { Box, styled } from '@mui/material'
import { DRAWER_WIDTH } from 'constants/layout'

const MainLayout = styled(Box, {
  shouldForwardProp: prop => prop !== 'open'
})<{
  open?: boolean
}>(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  marginLeft: 0,
  ...(open === true && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: DRAWER_WIDTH
  })
}))

const NivosMenuIcon = styled(Menu, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosMessageIcon = styled(Message, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosDashboardIcon = styled(DashboardTwoTone, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosNotificationIcon = styled(NotificationsActive, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosAccountIcon = styled(AccountBoxTwoTone, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosPaymentIcon = styled(Payments, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosBookedIcon = styled(BookmarkAdded, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosReportIcon = styled(Report, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

const NivosFileIcon = styled(AttachFile, {
  shouldForwardProp: propName => propName !== 'colorStr'
})<{ colorStr: string }>(({ theme, colorStr }) => ({
  color: colorStr
}))

export {
  MainLayout,
  NivosMenuIcon,
  NivosMessageIcon,
  NivosDashboardIcon,
  NivosNotificationIcon,
  NivosAccountIcon,
  NivosPaymentIcon,
  NivosBookedIcon,
  NivosReportIcon,
  NivosFileIcon
}
